import { useContext } from 'react';
import { useStyletron } from 'baseui';
import { Pill } from '@gtintel/platform-atoms';
import { NPRequestStatus } from '@gtintel/platform-types';
import { COLOURS, NPRequestStatusColourMap, formatDate, formatDateTime } from '@gtintel/platform-utils';
import { AssignmentContext } from '../context';
export default () => {
  const assignmentCtx = useContext(AssignmentContext);
  const [css] = useStyletron();
  if (!assignmentCtx) {
    return null;
  }
  return <div className={css({
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    marginBottom: '28px'
  })} data-testid="assignment-properties-card">
      <Pill colour={COLOURS.green}>
        <strong>Due Date:</strong> {formatDate(assignmentCtx.dueDate())}
      </Pill>
      <Pill colour={COLOURS.blue}>
        <strong>Fee:</strong> {assignmentCtx.currency()}
        {assignmentCtx.fee()}
      </Pill>

      {assignmentCtx.acceptedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Accepted]}>
          <strong>Accepted Date:</strong>{' '}
          {formatDateTime(assignmentCtx.acceptedDate())}
        </Pill>}
      {assignmentCtx.activatedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Assigned]}>
          <strong>Activated Date:</strong>{' '}
          {formatDateTime(assignmentCtx.activatedDate())}
        </Pill>}
      {assignmentCtx.submittedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Submitted]}>
          <strong>Submitted Date:</strong>{' '}
          {formatDateTime(assignmentCtx.submittedDate())}
        </Pill>}
      {assignmentCtx.finishedDate() && <Pill colour={NPRequestStatusColourMap[NPRequestStatus.Finished]}>
          <strong>Finished Date:</strong>{' '}
          {formatDateTime(assignmentCtx.finishedDate())}
        </Pill>}
    </div>;
};